/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BauNebenGewerbeSektor {
    Asphaltierer = 'Asphaltierer',
    Baumaschinenverleiher = 'Baumaschinenverleiher',
    Baustofferzeuger = 'Baustofferzeuger',
    Bauwerksabdichter = 'Bauwerksabdichter',
    Betonwarenerzeuger = 'Betonwarenerzeuger',
    Bodenleger = 'Bodenleger',
    Brunnenmeister = 'Brunnenmeister',
    Geruestverleiher = 'Geruestverleiher',
    Gipser = 'Gipser',
    Kalkbrennereien = 'Kalkbrennereien',
    Pflasterer = 'Pflasterer',
    Sprengungsunternehmer = 'Sprengungsunternehmer',
    Sandkiesschottererzeuger = 'Sandkiesschottererzeuger',
    Steinbruchunternehmen = 'Steinbruchunternehmen',
    Stuckateureundtrockenausbauer = 'Stuckateureundtrockenausbauer',
    Steinmetze = 'Steinmetze',
    Tiefbohrunternehmer = 'Tiefbohrunternehmer',
    Waermekaelteschallundbranddammer = 'Waermekaelteschallundbranddammer'
  }

    export const BauNebenGewerbeSektorTranslocoMap: Record<BauNebenGewerbeSektor, string> = {
    [BauNebenGewerbeSektor.Asphaltierer]: 'bauNebenGewerbeSektor.asphaltierer',
    [BauNebenGewerbeSektor.Baumaschinenverleiher]: 'bauNebenGewerbeSektor.baumaschinenverleiher',
    [BauNebenGewerbeSektor.Baustofferzeuger]: 'bauNebenGewerbeSektor.baustofferzeuger',
    [BauNebenGewerbeSektor.Bauwerksabdichter]: 'bauNebenGewerbeSektor.bauwerksabdichter',
    [BauNebenGewerbeSektor.Betonwarenerzeuger]: 'bauNebenGewerbeSektor.betonwarenerzeuger',
    [BauNebenGewerbeSektor.Bodenleger]: 'bauNebenGewerbeSektor.bodenleger',
    [BauNebenGewerbeSektor.Brunnenmeister]: 'bauNebenGewerbeSektor.brunnenmeister',
    [BauNebenGewerbeSektor.Geruestverleiher]: 'bauNebenGewerbeSektor.geruestverleiher',
    [BauNebenGewerbeSektor.Gipser]: 'bauNebenGewerbeSektor.gipser',
    [BauNebenGewerbeSektor.Kalkbrennereien]: 'bauNebenGewerbeSektor.kalkbrennereien',
    [BauNebenGewerbeSektor.Pflasterer]: 'bauNebenGewerbeSektor.pflasterer',
    [BauNebenGewerbeSektor.Sprengungsunternehmer]: 'bauNebenGewerbeSektor.sprengungsunternehmer',
    [BauNebenGewerbeSektor.Sandkiesschottererzeuger]: 'bauNebenGewerbeSektor.sandkiesschottererzeuger',
    [BauNebenGewerbeSektor.Steinbruchunternehmen]: 'bauNebenGewerbeSektor.steinbruchunternehmen',
    [BauNebenGewerbeSektor.Stuckateureundtrockenausbauer]: 'bauNebenGewerbeSektor.stuckateureundtrockenausbauer',
    [BauNebenGewerbeSektor.Steinmetze]: 'bauNebenGewerbeSektor.steinmetze',
    [BauNebenGewerbeSektor.Tiefbohrunternehmer]: 'bauNebenGewerbeSektor.tiefbohrunternehmer',
    [BauNebenGewerbeSektor.Waermekaelteschallundbranddammer]: 'bauNebenGewerbeSektor.waermekaelteschallundbranddammer',
    };

    export const BauNebenGewerbeSektorOptions = [
  { value: BauNebenGewerbeSektor.Asphaltierer, labelKey: 'bauNebenGewerbeSektor.asphaltierer' },
  { value: BauNebenGewerbeSektor.Baumaschinenverleiher, labelKey: 'bauNebenGewerbeSektor.baumaschinenverleiher' },
  { value: BauNebenGewerbeSektor.Baustofferzeuger, labelKey: 'bauNebenGewerbeSektor.baustofferzeuger' },
  { value: BauNebenGewerbeSektor.Bauwerksabdichter, labelKey: 'bauNebenGewerbeSektor.bauwerksabdichter' },
  { value: BauNebenGewerbeSektor.Betonwarenerzeuger, labelKey: 'bauNebenGewerbeSektor.betonwarenerzeuger' },
  { value: BauNebenGewerbeSektor.Bodenleger, labelKey: 'bauNebenGewerbeSektor.bodenleger' },
  { value: BauNebenGewerbeSektor.Brunnenmeister, labelKey: 'bauNebenGewerbeSektor.brunnenmeister' },
  { value: BauNebenGewerbeSektor.Geruestverleiher, labelKey: 'bauNebenGewerbeSektor.geruestverleiher' },
  { value: BauNebenGewerbeSektor.Gipser, labelKey: 'bauNebenGewerbeSektor.gipser' },
  { value: BauNebenGewerbeSektor.Kalkbrennereien, labelKey: 'bauNebenGewerbeSektor.kalkbrennereien' },
  { value: BauNebenGewerbeSektor.Pflasterer, labelKey: 'bauNebenGewerbeSektor.pflasterer' },
  { value: BauNebenGewerbeSektor.Sprengungsunternehmer, labelKey: 'bauNebenGewerbeSektor.sprengungsunternehmer' },
  { value: BauNebenGewerbeSektor.Sandkiesschottererzeuger, labelKey: 'bauNebenGewerbeSektor.sandkiesschottererzeuger' },
  { value: BauNebenGewerbeSektor.Steinbruchunternehmen, labelKey: 'bauNebenGewerbeSektor.steinbruchunternehmen' },
  { value: BauNebenGewerbeSektor.Stuckateureundtrockenausbauer, labelKey: 'bauNebenGewerbeSektor.stuckateureundtrockenausbauer' },
  { value: BauNebenGewerbeSektor.Steinmetze, labelKey: 'bauNebenGewerbeSektor.steinmetze' },
  { value: BauNebenGewerbeSektor.Tiefbohrunternehmer, labelKey: 'bauNebenGewerbeSektor.tiefbohrunternehmer' },
  { value: BauNebenGewerbeSektor.Waermekaelteschallundbranddammer, labelKey: 'bauNebenGewerbeSektor.waermekaelteschallundbranddammer' },
    ];

